webpackJsonp([4098895500148],{

/***/ 324:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.query = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(9);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _lodash = __webpack_require__(10);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _utils = __webpack_require__(18);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SitemapPage = function SitemapPage(_ref) {
	  var data = _ref.data;
	
	
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(
	      'ul',
	      null,
	      data.allGoogleSheetFoodsRow.edges.map(function (_ref2) {
	        var node = _ref2.node;
	        return _react2.default.createElement(
	          'li',
	          { key: node.id },
	          _react2.default.createElement(
	            _gatsbyLink2.default,
	            { to: (0, _utils.createSlugFromTitle)(node.title) },
	            node.title
	          )
	        );
	      })
	    )
	  );
	};
	
	// Utils
	var query = exports.query = '** extracted graphql fragment **';
	
	exports.default = SitemapPage;

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-sitemap-js-da0a6f3a16ee310e165d.js